
class AnswerSection extends HTMLElement{
  constructor(){
    super();

    this.question = this.querySelector('.click-area');
    this.answer = this.querySelector('.answer-wrapper');
    this.positive = this.querySelector('.plus-image');
    this.negative = this.querySelector('.negative-image');
    
    this.question.addEventListener('click',this.onButtonClick.bind(this));
    
  }
  onButtonClick(){
    if(this.answer.hasAttribute("style")){
      this.answer.removeAttribute("style");
      this.positive.setAttribute("style", "display:block" )
      this.negative.setAttribute("style", "display:none" )
    }else{
      this.answer.setAttribute("style", "display:block; margin:10px 0");
      this.positive.setAttribute("style", "display:none" )
      this.negative.setAttribute("style", "display:block; margin-top:10px" )
    }
  }
}

customElements.define("answer-section", AnswerSection);
